import React from 'react'

import { ButtonClean, PriceString } from '@fourthwall/components'
import { useThirdPartyLogisticsOptionsQuery } from '@modules/Dashboard/hooks/useThirdPartyLogisticsOptionsQuery'

import type { OfferQueryResponse } from '../../../../../hooks'
import * as S from './Shipping3plDescription.styled'

export const Shipping3plDescription = ({
  shippingConfig,
}: {
  shippingConfig?: OfferQueryResponse['config']['shippingConfig']
}) => {
  const { thirdPartyLogisticsOptionsQuery } = useThirdPartyLogisticsOptionsQuery()

  if (!thirdPartyLogisticsOptionsQuery.data) {
    return null
  }

  const { shippingFirstItemFee, shippingNextItemFee } = thirdPartyLogisticsOptionsQuery.data

  return (
    <S.Text>
      Send your products to us and we’ll handle shipping for you. When we ship an order, we’ll
      charge you{' '}
      <PriceString value={shippingFirstItemFee.value} currency={shippingFirstItemFee.currency} />{' '}
      for the first item +{' '}
      <PriceString value={shippingNextItemFee.value} currency={shippingNextItemFee.currency} /> for
      each additional item in the shipment.{' '}
      {shippingConfig?.shippingPackageStorageFee?.value &&
      shippingConfig?.shippingPackageStorageFee?.value > 0 ? (
        <>
          We also charge a{' '}
          <PriceString
            value={shippingConfig?.shippingPackageStorageFee.value}
            currency={shippingConfig?.shippingPackageStorageFee.currency}
          />{' '}
          per item per month storage fee.
        </>
      ) : null}{' '}
      <ButtonClean
        appearance="secondary"
        label="Learn more"
        href="https://help.fourthwall.com/hc/en-us/articles/13331284092187-Fourthwall-fulfillment-service-guide"
        target="_blank"
      />
    </S.Text>
  )
}
